// extracted by mini-css-extract-plugin
export default {"root":"vLERJKY","editor":"INRmz4E"};